
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanieWprzyszlosc(draggedId,targetProcesorId,dropDate,refreshGantAll) {

// id = procesor id
// console.log(" dropDate: "+dropDate)
  
  axios
  .get(IP + "API_0004_gant_procedura_przesun_zadanie_w_przyszlosc/"+draggedId+"/"+targetProcesorId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })


}


